import React from "react";
import { values } from "ramda";
import { DIRECTION } from "../../common/constants";

const Direction = (props) => (
    <select className="x-recommendation-direction" value={props.value} onChange={props.onChange} style={{width: 80}}>{
        values(DIRECTION).map(direction => (
            <option key={direction} value={direction} >{ capitalise(direction) }</option>
        ))
    }</select>
);
Direction.propTypes = {
    onChange: React.PropTypes.func,
    value: React.PropTypes.string
};

function capitalise(string) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

export default Direction;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/Direction.js
 **/